import { render } from "./Import_Saving_Accounts.vue?vue&type=template&id=73ae9b34"
import script from "./Import_Saving_Accounts.vue?vue&type=script&lang=js"
export * from "./Import_Saving_Accounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__